const MetricsGetter = {
    summary: (state) => state.summary,
    dashboard: state => state.dashboard,
    balances: state => state.balances,
    walletOverview: state => state.walletOverview
};

export default MetricsGetter;